var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSerbia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 39.9999C31.0455 39.9999 39.9998 31.0456 39.9998 19.9999C39.9998 8.95418 31.0455 -0.00012207 19.9998 -0.00012207C8.95414 -0.00012207 -0.000167847 8.95418 -0.000167847 19.9999C-0.000167847 31.0456 8.95414 39.9999 19.9998 39.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 -0.00012207C8.95421 -0.00012207 -0.000167847 8.95425 -0.000167847 19.9999C-0.000167847 22.4463 0.43991 24.7898 1.24382 26.9564H38.7559C39.5598 24.7898 39.9998 22.4463 39.9998 19.9999C39.9998 8.95425 31.0455 -0.00012207 19.9998 -0.00012207Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 -9.15527e-05C11.4006 -9.15527e-05 4.06973 5.42741 1.24387 13.0434H38.756C35.93 5.42741 28.5992 -9.15527e-05 19.9999 -9.15527e-05V-9.15527e-05Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17168 11.3043V21.2813C5.17168 26.9566 12.5858 28.6956 12.5858 28.6956C12.5858 28.6956 19.9999 26.9566 19.9999 21.2813V11.3043H5.17168Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23782 13.0434H16.9335V9.56516L15.1944 10.4347L12.5857 7.82602L9.97696 10.4347L8.23782 9.56516V13.0434Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2607 22.6704L12.6085 17.0182L6.9563 22.6704L8.80091 24.515L12.6085 20.7075L16.4161 24.515L18.2607 22.6704Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2607 17.3913H15.6235C15.7718 17.1354 15.8581 16.839 15.8581 16.5219C15.8581 15.5613 15.0794 14.7828 14.1189 14.7828C13.4553 14.7828 12.8789 15.1545 12.5857 15.701C12.2925 15.1546 11.7162 14.7828 11.0525 14.7828C10.0921 14.7828 9.31339 15.5613 9.31339 16.5219C9.31339 16.839 9.39964 17.1355 9.54792 17.3913H6.95636C6.95636 18.3519 7.793 19.1305 8.75339 19.1305H8.6955C8.6955 20.091 9.47409 20.8696 10.4346 20.8696C10.4346 21.7201 11.0454 22.4266 11.8521 22.5779L10.4818 25.6718C11.1385 25.9387 11.8561 26.087 12.6086 26.087C13.3611 26.087 14.0788 25.9387 14.7355 25.6718L13.3652 22.5779C14.1718 22.4268 14.7826 21.7202 14.7826 20.8696C15.7432 20.8696 16.5218 20.091 16.5218 19.1305H16.4639C17.4242 19.1305 18.2607 18.3518 18.2607 17.3913V17.3913Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerbia);
export default __webpack_public_path__ + "static/media/serbia.2241b8a01125e9cb95d44fe5039cd881.svg";
export { ForwardRef as ReactComponent };